import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import LicenseDropzone from '../Inputs/LicenseDropzone';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

export default function LicenseUpload(props) {
  const { open, handleClose, setBackdropOpen, onUploadFiles, setModelOpen, setFile } = props;
  const [preImg, setPreImg] = useState();

  const handleDropImg = (acceptedFiles, id) => {
    if (!!acceptedFiles && acceptedFiles.length > 0) {
      setBackdropOpen(true);
      const reader = new FileReader();
      reader.readAsDataURL(acceptedFiles[0]);
      return new Promise((resolve) => {
        reader.onload = () => {
          setPreImg(reader.result);
          resolve();
          setBackdropOpen(false);
        };
      });
    }
  };

  useEffect(async () => {
    setPreImg(null);
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title">
      <DialogTitle id="draggable-dialog-title">사업자등록증 업로드</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="red">
          ※ 정보를 찾을수 없습니다. 가입하시려는 회사를 파악하기 위한 사업자등록증을 업로드 해주세요.
        </Typography>
        <Divider />
        {preImg && <img src={preImg} alt="panoramaPre" width="50%" height="50%" style={{ display: 'block', margin: '0px auto' }} />}
        <LicenseDropzone
          accept={{ 'image/png': ['.png'], 'image/jpg': ['.jpg'], 'image/jpeg': ['.jpeg'] }}
          onAcceptedFiles={handleDropImg}
          id="panorama"
          maxFiles={1}
          maxFilesize={5242880}
          onUploadFiles={onUploadFiles}
          setModelOpen={setModelOpen}
          setFile={setFile}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
